import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography, SvgIcon } from "@material-ui/core";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { styles } from "./constants/styles";
import messages from "./constants/messages";
import "./constants/styleSheet.css"
import { FormattedHTMLMessage } from "../../../locale";

type Props = WithStyles<typeof styles>;

const PasswordResetRequestPage: React.FC<Props> = (props: Props) => {
  const { classes } = props;
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <SvgIcon fontSize={"large"} color={"primary"}>
          <CheckCircleOutline />
        </SvgIcon>
        <Typography className={classes.header}>
          <FormattedHTMLMessage {...messages.header} />
        </Typography>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(PasswordResetRequestPage);
